 function executeWhenClassApplied() {
      const container = document.querySelector('.container-fluid');
      const boxProductQuantities = container.querySelectorAll('.boxproduct--quantity');
      // Iterate through each element
      boxProductQuantities.forEach(function(div) {
        // Get the text content of the div
        const textContent = div.textContent.trim();
        
        // Extract the first word
        let firstWord = textContent.split(' ')[0]; 
        if(textContent.split(' ')[1]){
          firstWord += textContent.split(' ')[1];
        }
        // Update the div with the first word
        div.textContent = firstWord;
        
        // Make the div visible
        div.style.display = 'block';
      });
  }
function updatemenu() {
    const menuItems = document.querySelectorAll('.header--mmenu--item');
    menuItems.forEach(function(menuItem) {
        menuItem.addEventListener('click', function(event) {
            event.stopPropagation();
            document.querySelectorAll('.header--mobile--img-row.mm-spn--open').forEach(function(openSubmenu) {
                if (openSubmenu !== menuItem.querySelector('.header--mobile--img-row')) {
                    openSubmenu.classList.remove('mm-spn--open');
                }
            });

            const submenu = menuItem.querySelector('.header--mobile--img-row');
            submenu.classList.toggle('mm-spn--open');
            menuItem.classList.toggle('header--mmenu--item--active');
            const parentMenu = menuItem.closest('.header--mmenu');
            if (parentMenu) {
                parentMenu.classList.toggle('mm-spn--parent');
            }

            const firstChildList = menuItem.querySelector('.header--mobile--list');
            if (firstChildList) {
                firstChildList.classList.remove('active');
            }

            menuItems.forEach(function(item) {
                if (item !== menuItem && item.classList.contains('header--mmenu--item--active')) {
                    item.classList.remove('header--mmenu--item--active');
                }
            });
        });
    });

    const mobileLists = document.querySelectorAll('.header--mobile--list');
    mobileLists.forEach(function(mobileList) {
        mobileList.addEventListener('click', function(event) {
            event.preventDefault();
            event.stopPropagation();
            mobileLists.forEach(function(item) {
                if (item !== mobileList) {
                    item.classList.remove('active');
                }
            });
            mobileList.classList.toggle('active');
        });
    });

    const mobileTitles = document.querySelectorAll('.header--mobile--title a');
    mobileTitles.forEach(function(mobileTitle) {
        mobileTitle.addEventListener('click', function(event) {
            event.stopPropagation();
        });
    });

    document.addEventListener('click', function() {
        document.querySelectorAll('.header--mobile--img-row.mm-spn--open').forEach(function(openSubmenu) {
            openSubmenu.classList.remove('mm-spn--open');
        });
        document.querySelectorAll('.header--mmenu.mm-spn--parent').forEach(function(parentMenu) {
            parentMenu.classList.remove('mm-spn--parent');
        });
        menuItems.forEach(function(item) {
            item.classList.remove('header--mmenu--item--active');
        });
        mobileLists.forEach(function(item) {
            item.classList.remove('active');
        });
    });
}
function addSlide() {
  if ($('.product.main-product').length > 0) {
    const imageUrl = document.querySelector('.product.main-product').getAttribute('data-image');

    if (imageUrl) {
      // Generate the HTML for the new slide in the main slider
      const newSlideHTML = `
        <a id="featured-image-display-container" data-href="${imageUrl}" class="product--slider--item" data-remove-slide="true">
          <img id="featured-image-display-img" src="${imageUrl}" alt="" class="img-fluid w-100" height="" width="">
        </a>
      `;

      // Initialize slider if not already initialized
      if (!$('.product--slider').hasClass('slick-initialized')) {
        $('.product--slider').slick();
      }

      // Check if the main slider already contains a slide with this image
      if ($('.product--slider img[src="' + imageUrl + '"]').length === 0) {
        // Add the new slide directly using slickAdd
        $('.product--slider').slick('slickAdd', newSlideHTML, 0);
        $('.product--slider').slick('slickGoTo', 0); // Optionally go to the first slide
      }

      // Generate the HTML for the new slide in the navigation slider
      const newSlideHTMLnav = `
        <div class="product--navs--item">
          <img src="${imageUrl}" alt="" class="img-fluid">
        </div>
      `;

      // Check if the navigation slider already contains a slide with this image
      if ($('.product--navs img[src="' + imageUrl + '"]').length === 0) {
        // Add the new slide to the navigation slider
        $('.product--navs').slick('slickAdd', newSlideHTMLnav, 0);
      }

      // Resize both sliders to adjust to the new slides
      $('.product--slider').slick('setPosition'); // Use setPosition to reflow the slides correctly
      $('.product--navs').slick('setPosition');
    }
  }
}



function removeSlide() {
  if ($('.product.main-product').length > 0) {
    const imageUrl = $('.product.main-product').attr('data-image');

    if (imageUrl) {
      // Find the corresponding slide in the main slider
      $('.product--slider--item').each(function(index, slide) {
        if ($(slide).attr('data-remove-slide') === "true" && $(slide).find('img').attr('src') === imageUrl) {
          // Remove the slide from the main slider
          $('.product--slider').slick('slickRemove', index);
        }
      });

      // Find the corresponding slide in the navigation slider
      $('.product--navs--item').each(function(index, slide) {
        if ($(slide).find('img').attr('src') === imageUrl) {
          // Remove the slide from the navigation slider
          $('.product--navs').slick('slickRemove', index);
        }
      });

      // Resize both sliders after removing the slide(s)
      $(".product--slider").slick("setPosition");
      $(".product--navs").slick("setPosition");
    }
  }
}

function createSliderHtml() {
  if($('.homeslider').length > 0){
     const element = document.querySelector('.homeslider');
     if(element){
        const mainSlider = $(element).slick('getSlick');
        const slide = document.querySelector(".custom-test-slider-slide-for-ab002").cloneNode(true);
        const slideHTML = slide; // Get the HTML string from the cloned slide
        if($(element).find(".custom-slide-for-test").length <= 0){
          mainSlider.slickAdd(slideHTML);
        mainSlider.slickGoTo(mainSlider.getCurrent());
        }
        
    }
  }
}
const removeSlides = async (sliderElement, conditionCallback) => {
  // Get the Slick slider instance
  const slider = $(sliderElement).slick('getSlick');

  // Iterate through the slides from last to first to avoid indexing issues
  const removedCustom = async () => {
     for (let i = slider.$slides.length - 1; i >= 0; i--) {
      const slide = slider.$slides.get(i);
      if (conditionCallback(slide, i)) {
        slider.slickRemove(i);
      }
    }
 };
  return await removedCustom();
};

async function removeslideHtml() {
  if($('.homeslider').length > 0){
    const element = document.querySelector('.homeslider');
      await removeSlides(element, (slide, index) => {
          return slide.querySelectorAll('.custom-slide-for-test').length > 0;
     });
    const mainSlider = $(element).slick('getSlick');
    mainSlider.slickGoTo(mainSlider.getCurrent());
  }
 }
function changeTextToAjouter() {
  var buttons = document.getElementsByClassName('addtocart--text');
  var prices = document.querySelectorAll('.addtocart .addtocart--price');
  var boxproduct_quantity = document.querySelectorAll('.prodlisting .boxproduct--quantity');
  for (var i = 0; i < buttons.length; i++) {
    buttons[i].textContent = 'Ajouter au panier';
        buttons[i].classList.add('hide-after');
     prices[i].style.display = 'none';
    boxproduct_quantity[i].style.display = 'none';
  }
}
function revertTextToJachete() {
  var buttons = document.getElementsByClassName('addtocart--text');
  var prices = document.querySelectorAll('.addtocart .addtocart--price');
   var boxproduct_quantity = document.querySelectorAll('.prodlisting .boxproduct--quantity');
  for (var i = 0; i < buttons.length; i++) {
    buttons[i].textContent = 'J’achète';
        buttons.classList.remove('hide-after');
     prices[i].style.display = 'block';
     boxproduct_quantity[i].style.display = 'block';
  }
}
const initializeBodyObservation1 = () => {
    const targetNode = document.body;
    const config = { attributes: true };
  
    const callback = function(mutationsList, observer) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (document.body.classList.contains("hw-abt-6-1") || document.body.classList.contains("hw-abt-6-2")) {
            changeAddToCartText();
          }else if(document.body.classList.contains("hw-abt-12-1")){
            sticky_add_to_cart()
          }else if(document.body.classList.contains("hw-abt-3-1")){
            updatemenu()
          }else if (document.body.classList.contains("hw-abt-10-1")) {
            let carouselElement = document.querySelector('.reference--carrousel');
          if ($(carouselElement).hasClass('slick-initialized')) {
            $(carouselElement).slick('unslick');
           }
         }
         else if(document.body.classList.contains("hw-abt-7-1") || document.body.classList.contains("hw-abt-7-2")){
            changeTextToAjouter();
          }
          else if(document.body.classList.contains("hw-abt-7-3")){
            executeWhenClassApplied();
          }     
          else if(document.body.classList.contains("hw-abt-14-1")){
          addSlide();
          }
          else if(document.body.classList.contains("hw-abt-2-1")){
           //createSliderHtml();
          }else{
            /*if(hwabt2 == 'test'){
               setTimeout(function(){
                  removeslideHtml();
               },1000);
            }*/
           
           removeSlide();
          }
        }
      }
    };
  
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }

jQuery(document).ready(function($){
  $(".homeslider").slick({
      infinite: true,
      // dots: true,
      arrows: true,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      prevArrow: '<button type="button" class="slick-prev slick-arrow" style=""><span class="icon-Arrow-left"></span></button>',
      nextArrow: '<button type="button" class="slick-next slick-arrow" style=""><span class="icon-Arrow-right"></span></button>',
      responsive: [
       {
         breakpoint: 769,
         settings: {
           dots: true,
           arrows: false
         }
       }
     ]
   });

   $('.Product-image-slider').slick({
    "infinite": false,
    "arrows": true,
    "autoplay": false,
    "slidesToShow": 6,
    "slidesToScroll": 1,
    "vertical": true,
    "focusOnSelect": true,
    "asNavFor": "#prodslider",
    "prevArrow": '<button type="button" class="slick-prev slick-arrow" style=""><span class="icon-left"></span></button>',
    "nextArrow": '<button type="button" class="slick-next slick-arrow" style=""><span class="icon-right"></span></button>',
    "responsive": [
      {
        "breakpoint": 992,
        "settings": {
          "vertical": false,
          "slidesToShow": 5,
          "slidesToScroll": 1
        }
      }
    ]
});

 $('.Product-image-prodslider').slick({
    "infinite": false,
    "arrows": true,
    "dots": false,
    "autoplay": true,
    "adaptiveHeight": false,
    "slidesToShow": 1,
    "slidesToScroll": 1,
    "fade": true,
    "adaptativeHeight": true,
    "asNavFor": "#prodnavs",
    // "prevArrow": '<button type="button" class="slick-prev slick-arrow" style=""><span class="icon-Arrow-left"></span></button>',
    // "nextArrow": '<button type="button" class="slick-next slick-arrow" style=""><span class="icon-Arrow-right"></span></button>',
    "responsive": [
      {
        "breakpoint": 992,
        "settings": {
          "dots": true,
          "arrows": false
        }
      }
    ]
});
 });

document.addEventListener('DOMContentLoaded', function() {
  initializeBodyObservation1();
  const bodyClassList = document.body.classList;
  if (bodyClassList.contains('hw-abt-3-1') || bodyClassList.contains('hw_03_v1')) {
    updatemenu();
  }
  /*if(hwabt2 == 'v1'){
   setTimeout(function(){
      createSliderHtml();
   },1000);
  }*/
    function calculateAndAppendUnitPrices() {
        // Select all elements with the class 'value-right'
        const valueRightElements = document.querySelectorAll('.value-right');

        // If elements are not found, return and wait for the next interval
        if (valueRightElements.length === 0) {
            return;
        }

        // Retrieve the first word of the product title
        const productTitleElement = document.querySelector('.product--title');
        const firstWord = productTitleElement ? productTitleElement.innerText.split(' ')[0] : '';

        // Loop through each element
        valueRightElements.forEach(function(element) {
            // Check if the unit price has already been appended to avoid duplication
            if (element.querySelector('.unit-price')) {
                return;
            }

            // Retrieve the number of products
            const productTextElement = element.querySelector('.title-variant');
            const numberOfProducts = parseInt(productTextElement.innerText.replace(/\D/g, '')); // Extract digits from the text

            // Update the text content of the title-variant element
            productTextElement.innerText = `${numberOfProducts} ${firstWord}`;

            // Retrieve the total price
            const priceElement = element.querySelector('.price-new-form');
            const totalPrice = parseFloat(priceElement.innerText.replace('€', ''));

            // Calculate the unit price
            const unitPrice = totalPrice / numberOfProducts;

            // Create a new span element to display the unit price
            const unitPriceElement = document.createElement('span');
            unitPriceElement.innerText = ` (${unitPrice.toFixed(2)}€/unité)`;
            unitPriceElement.classList.add('unit-price'); // Optional: Add a class for styling

            // Append the unit price to the element
            priceElement.appendChild(unitPriceElement);

            // Retrieve the discount percentage
            const discountElement = element.querySelector('.best-title');
            let discountText = false;
            if(discountElement){
               discountText = discountElement.innerText.match(/\d+%/); // Extract the percentage value
            }
           

            if (discountText) {
                // Select the corresponding offer-image element
                const offerImageElement = element.previousElementSibling;
                if (offerImageElement && offerImageElement.classList.contains('offer-image')) {
                    // Create a new container div
                    const containerDiv = document.createElement('div');
                    containerDiv.classList.add('offer-container'); // Optional: Add a class for styling

                    // Move the existing img and span elements to the new container
                    const imgElement = offerImageElement.querySelector('img');
                    const discountSpan = document.createElement('span');
                    discountSpan.innerText = discountText[0]; // Use the extracted percentage
                    discountSpan.classList.add('discount-text'); // Optional: Add a class for styling

                    containerDiv.appendChild(imgElement);
                    containerDiv.appendChild(discountSpan);

                    // Replace the content of offerImageElement with the new container
                    offerImageElement.innerHTML = '';
                    offerImageElement.appendChild(containerDiv);
                }
            }
        });

        // Clear the interval once elements are processed
        clearInterval(intervalId);
    }

    // Check for the elements every 500 milliseconds
    const intervalId = setInterval(calculateAndAppendUnitPrices, 500);
});
function changeAddToCartText() {
    const atcElements = document.querySelector('[name="checkout"]');
    atcElements.textContent = 'Valider mon panier';
      const img = document.createElement('img');
      img.src = 'https://cdn.shopify.com/s/files/1/0262/5313/1854/files/Group_97_3.png?v=1718783327';
      img.alt = 'Image description';
      atcElements.appendChild(img); 
  }
function addtocarttextasitis() {
  const atcElements = document.querySelector('[name="checkout"]');
    atcElements.textContent = 'Passer commande';
      const img = document.createElement('img');
      img.src = '';
      img.alt = '';
      //atcElements.appendChild(img); 
}
document.addEventListener('DOMContentLoaded', () => {
    if (document.body.classList.contains('hw-abt-6-1') || document.body.classList.contains('hw-abt-6-2')) {
        changeAddToCartText();
      }
  
  const initializeBodyObservation1 = () => {
    const targetNode = document.body;
    const config = { attributes: true };
  
    const callback = function(mutationsList, observer) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes') {
          if (document.body.classList.contains("hw-abt-6-1") || document.body.classList.contains("hw-abt-6-2")) {
            changeAddToCartText();
          }else if(document.body.classList.contains("hw-abt-6-3") || document.body.classList.contains("hw-abt-6-4")){
            addtocarttextasitis()
          }
          else if(document.body.classList.contains("hw-abt-12-1")){
            sticky_add_to_cart()
          }
        }
      }
    };
  
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  };
  
  initializeBodyObservation1();
  if (document.getElementById('minicart').classList.contains('v1') || document.getElementById('minicart').classList.contains('v2')) {
  changeAddToCartText();
  }
   if (document.querySelector('.product.main-product') && (document.querySelector('.product.main-product').classList.contains('v1') || document.body.classList.contains("hw-abt-12-1"))) {
  sticky_add_to_cart();
}
});
 function sticky_add_to_cart() {
      document.addEventListener('scroll', function () {
        const descriptionContent = document.querySelector('.description--content');
        const productFormButtons = document.querySelector('.product-form__buttons');
        const rectDescription = descriptionContent.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;

        const pTagSelector = '.sticky-info';
        let pTag = productFormButtons.querySelector(pTagSelector);
         if (!pTag) {
           pTag = document.createElement('p');
           pTag.textContent = window.buttonptext;
           pTag.classList.add('sticky-info');
          productFormButtons.appendChild(pTag);
         }

        if (window.innerWidth <= 768) { // Mobile condition
          if (rectDescription.top <= windowHeight) {
            productFormButtons.classList.add('fixed');
          } else {
            productFormButtons.classList.remove('fixed');
          }
        } else { // Desktop condition
          if (rectReference.top <= windowHeight) {
            productFormButtons.classList.add('fixed');
          } else {
            productFormButtons.classList.remove('fixed');
          }
        }
      });
    }
document.addEventListener('DOMContentLoaded', function() {
  initializeBodyObservation1();
  if (document.body.classList.contains('hw-abt-6-1') || document.body.classList.contains('hw-abt-6-2')) {
  changeAddToCartText();
}
 /* if (document.querySelector('.prodlisting .container-fluid').classList.contains('hw-abt-7-v1') || document.querySelector('.prodlisting .container-fluid').classList.contains('hw-abt-7-v2')) {
  changeTextToAjouter();
  } */
  // Make sure jQuery is loaded and initialized properly
let carouselElement = document.querySelector('.reference--carrousel');
if (carouselElement && carouselElement.classList.contains('v1')) {
    $('.reference--carrousel').slick('unslick');
} 
  
   const ab_test_7 = document.querySelector('.container-fluid.hw-abt-7-v3');
   if(ab_test_7){
   executeWhenClassApplied();
     }
});
function waitForSwiper(trigger) {
  var interval = setInterval(function () {
    if (typeof Swiper != "undefined") {
      clearInterval(interval);
      trigger();
    }
  }, 50);
  setTimeout(function () {
    clearInterval(interval);
  }, 15000);
}
if(document.querySelectorAll(".quick_link_header_wrapper").length > 0 && document.querySelectorAll(".quick_link_header_wrapper div.eg-active").length > 0){
    const acItem = document.querySelector(".quick_link_header_wrapper div.eg-active");
    let tabwidth = acItem.offsetWidth;
    document.querySelector(".eg-tabs-nav__position").style.cssText = '--width:' + tabwidth + 'px;--prevWidth:' + (acItem.offsetLeft) + 'px;';
    acItem.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }

